export default "/images/branding-urb.png?28db90f2c0c1683a84f6871981e99e2b";